import { Entity } from "../helpers/Entity"
import ExternalLink, { ExternalLinkDto } from "../integration/ExternalLink"

export type PriceLevelAttributesDto = {
    name: string
    externalLinks: ExternalLinkDto[]
    createdAt: string
}

export type PriceLevelDto = {
    id: string
    type: string
    attributes: PriceLevelAttributesDto
}

export default class PriceLevel implements Entity {
    dto: PriceLevelDto
    externalLinks: ExternalLink[]
    constructor(dto: PriceLevelDto) {
        this.dto = dto
        this.externalLinks = dto?.attributes?.externalLinks?.map(el => new ExternalLink(el))
    }

    isLoaded(): boolean {
        return this.dto.id != ""
    }

    getId(): string {
        return this.dto.id
    }

    getName(): string {
        return this.dto.attributes.name
    }

    getExternalLinks(): ExternalLink[] {
        return this.externalLinks
    }
}


// WEBPACK FOOTER //
// ./src/state/price-level/PriceLevel.ts